import { render, staticRenderFns } from "./formTable.vue?vue&type=template&id=38bb62f1"
import script from "./formTable.vue?vue&type=script&lang=js"
export * from "./formTable.vue?vue&type=script&lang=js"
import style0 from "./formTable.vue?vue&type=style&index=0&id=38bb62f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports